import { Formik, Form } from "formik";
import HeaderDescriptive from "src/components/HeaderDescriptive";
import PageHeader from "src/components/PageHeader";
import FormikField from "src/components/FormikField/FormikField";
import { useNavigate } from "react-router-dom";
import { FiUserPlus } from "react-icons/fi";
import { useEffect, useState } from "react";
import { post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";
import useGetCurrentURL from "src/utils/useGetCurrentURL";
import TwinButton from "src/components/TwinButton";
import { getData } from "src/actions/getData";

export default function AddUser() {
    const [roleOptions, setRoleOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const pathname = useGetCurrentURL();

    useEffect(() => {
        getData((result) => {
            if (Array.isArray(result)) {
                setRoleOptions(result.map(role => ({
                    value: role?.id,
                    label: role?.roleTranslate
                })));
            }
        }, "/roles");
    }, []);

    return (
        <>
            <PageHeader title="افزودن کاربر جدید" />
            <Formik
                initialValues={{
                    fullName: "",
                    email: "",
                    password: "",
                    roleId: "",
                }}
                onSubmit={async (values, { setErrors }) => {
                    setIsLoading(true);
                    try {
                        const response = await post("/register", values);
                        
                        if (response?.success || response?.status === 201) {
                            notify("کاربر با موفقیت به سیستم اضافه شد", "success");
                            navigate(pathname.slice(0, pathname.search("/add")));
                        } else {
                            notify("خطایی در ثبت اطلاعات رخ داده است", "error");
                        }
                    } catch (error) {
                        if (error?.response?.data) {
                            // ست کردن خطاهای اعتبارسنجی ارسال شده از سمت Serializer Django
                            setErrors(error.response.data);
                        }
                        notify("خطایی رخ داده است", "error");
                    } finally {
                        setIsLoading(false);
                    }
                }}
            >
                {({ values, errors, setFieldValue }) => (
                    <Form>
                        <div className="flex flex-col bg-white dark:bg-black rounded-2xl p-10 px-20">
                            <HeaderDescriptive
                                title="اطلاعات کاربر"
                                description="اطلاعات زیر را برای اضافه شدن کاربر تکمیل نمایید"
                            >
                                <FiUserPlus size={40} />
                            </HeaderDescriptive>
                            
                            <div className="flex gap-10 mt-10">
                                <div className="flex flex-col xl:grid gap-5 gap-y-9 grid-cols-2 w-full justify-center">
                                    <FormikField
                                        inputName="fullName"
                                        label="نام"
                                        placeholder="نام کامل کاربر را وارد کنید..."
                                        errors={errors}
                                    />
                                    <FormikField
                                        inputName="email"
                                        label="ایمیل"
                                        placeholder="ایمیل کاربر را وارد کنید..."
                                        errors={errors}
                                    />
                                    <FormikField
                                        type="password"
                                        inputName="password"
                                        label="گذرواژه"
                                        placeholder="گذرواژه کاربر را وارد کنید..."
                                        errors={errors}
                                    />
                                    <FormikField
                                        inputName="roleId"
                                        type="select"
                                        label="سطح دسترسی"
                                        placeholder="سطح دسترسی کاربر را وارد کنید..."
                                        errors={errors}
                                        options={roleOptions}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                    />
                                </div>
                            </div>

                            <TwinButton
                                rejectHandle={() => {
                                    navigate(pathname.slice(0, pathname.search("/add")));
                                }}
                                isLoading={isLoading}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
}